export default {
    getGlobalOS: (state) => state.globalOS,
    getGlobalPhonesModels: (state) => state.globalPhonesModels,
    getDonationPageOS: (state) => state.donationPageOS,
}
